import { UploadFlightsComponent } from './upload-flights/upload-flights.component';
import { RemoveFlightsComponent } from './remove-flights/remove-flights.component';

export { UploadFlightsComponent, RemoveFlightsComponent };
